/* Publish by EComposer at 2026-10-07 09:45:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3mbe2k0wwre"]=  window.__ectimmers["ecom-3mbe2k0wwre"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-3mbe2k0wwre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mbe2k0wwre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3unvez7cbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3unvez7cbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8b71cixbqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8b71cixbqr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4z2dokrr6xe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4z2dokrr6xe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75tajrtqdzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75tajrtqdzq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jls3b2w6ht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jls3b2w6ht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rwxij7fz4x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rwxij7fz4x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57ewchkbj8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57ewchkbj8y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fqnzmzsgr6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fqnzmzsgr6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3yw07acgfw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3yw07acgfw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lj157xdg2fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lj157xdg2fc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xw2rcgdpuhs"]=  window.__ectimmers["ecom-xw2rcgdpuhs"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-xw2rcgdpuhs"]["fdntu72hn"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xw2rcgdpuhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xw2rcgdpuhs', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dkxsjk808hq"]=  window.__ectimmers["ecom-dkxsjk808hq"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-dkxsjk808hq"]["x7dxdwv2y"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-dkxsjk808hq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dkxsjk808hq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ft1qlrqzhc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ft1qlrqzhc4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3uzkx3y1fjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3uzkx3y1fjd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}